import PropTypes from "prop-types";
import React from "react";
import { Property, Proposal } from "rsl-api-106/lib/types";

import EtabBlock from "@components/Etabs/EtabBlock";
import ProposalItem from "@components/Proposals/Proposal";

type ProposalBlockProps = {
  proposals: Proposal[];
  etab: Property;
  proposalActionText: string;
  singlePax: string;
  plurialPax: string;
};

const ProposalBlock: React.FC<ProposalBlockProps> = ({
  proposals,
  etab,
  proposalActionText,
  plurialPax,
  singlePax,
}) => {
  return (
    <>
      <div className="tw-mb-10">
        <EtabBlock etab={etab} />
        {proposals.map((item, index) => {
          return (
            <ProposalItem
              plurialPax={plurialPax}
              singlePax={singlePax}
              proposalActionText={proposalActionText}
              key={`proposal_${index}`}
              proposal={item}
            />
          );
        })}
      </div>
    </>
  );
};

ProposalBlock.propTypes = {
  //
};

export default ProposalBlock;
